import styled from 'styled-components'
import type {
  ForumQuillEditorRef} from '@/modules/forum/components';
import {
  ForumQuillEditor
} from '@/modules/forum/components'
import { useRef } from 'react'
import { Card } from '@/components_deprecated'
import type { VehicleDetailNode } from '@/modules/vehicles/types.graphql'
import { PERMISSIONS, quillValidation, usePermissions, useUser } from '@/utils'
import { useVehicleNoteMutations } from '../mutations.hooks'
import Delta from 'quill-delta'
import { useTranslate } from '@ur-solutions/react-hooks'

const Wrapper = styled(Card)`
  padding: 0;
`

interface Props {
  vehicle: VehicleDetailNode
}

export const CreateVehicleNote: React.FC<Props> = ({ vehicle }) => {
  const translations = useTranslate({
    addNote: 'vehicles.add-note',
  })
  const user = useUser()
  const quillRef = useRef<ForumQuillEditorRef>(null)

  const { hasPermissions } = usePermissions()
  const { createNote, loading } = useVehicleNoteMutations()

  const canAdd = hasPermissions(PERMISSIONS.vehicles.add.vehiclenote)

  const onSubmit = async (content: string) => {
    const delta = quillRef.current?.quill?.getContents()
    if (!quillValidation(delta)) return
    await createNote({
      variables: {
        input: {
          vehicle: vehicle.id,
          text: content,
          user: user.id,
        },
      },
      onCompleted() {
        if (!quillRef.current) return
        quillRef.current.quill?.setContents(new Delta())
      },
    })
  }

  if (!canAdd) return null

  return (
    <Wrapper>
      <ForumQuillEditor
        ref={quillRef}
        placeholder={translations.addNote}
        loading={loading}
        submitText={translations.addNote}
        onSubmit={onSubmit}
        noAttachments={false}
        minHeight="130px"
      />
    </Wrapper>
  )
}
